

import request from '@/utils/request.js'


// banner图等
export function getNewsBanner() {
  return request({
    url: `/dj-portal-api/ads/public/news`,
    method: "get",
  });
}
// 信息列表
export function getInfo(data) {
  return request({
    url: `/dj-portal-api/info/latestList`,
    method: "post",
    data
  });
}
// 分类信息列表
export function getListByCategory(data) {
  return request({
    url: `/dj-portal-api/info/listByCategory`,
    method: "post",
    data
  });
}
// 信息详情
export function getInfoDetail(data) {
  return request({
    url: `/dj-portal-api/info/detail`,
    method: "post",
    data
  });
}
// 热门信息
export function getHotList(data) {
  return request({
    url: `/dj-portal-api/info/hotList`,
    method: "post",
    data
  });
}